module.exports = __webpack_public_path__ + "img/07049a4.png";